import { DEST_SAND, MARK_DEST, MARK_DOTS, MARK_OFFSET } from '../brand/GromlyMark';

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  /** Brand ink (cream in dark mode) instead of the surrounding text colour.
   *  Always on for `lg`; leave it off inside buttons so the dots follow the label. */
  branded?: boolean;
}

const DIM = { xs: 16, sm: 20, md: 28, lg: 64 } as const;
const STEP_S = 0.18;

// The logo itself is the loader: its dots light up in turn towards the
// destination. With reduced motion it's the still logo.
export default function Spinner({ size = 'md', branded }: SpinnerProps) {
  const dim = DIM[size];
  const tone = branded || size === 'lg' ? 'text-[#0b1420] dark:text-[#faf7f0]' : '';
  return (
    <svg
      className={`gromly-loader shrink-0 ${tone}`} width={dim} height={dim} viewBox="0 0 100 100"
      aria-hidden
    >
      <g transform={MARK_OFFSET}>
        {MARK_DOTS.map((d, i) => (
          <circle key={d.cx} {...d} fill="currentColor" style={{ animationDelay: `${i * STEP_S}s` }} />
        ))}
        <circle
          {...MARK_DEST} fill={DEST_SAND}
          style={{ animationDelay: `${MARK_DOTS.length * STEP_S}s` }}
        />
      </g>
    </svg>
  );
}
